import axios from 'axios'

import { AUTH_ERROR, LOAD_USER, UPDATE_PROFILE } from './types'
import { firebase } from '../../firebase'

export const loadUser = (user) => async (dispatch) => {
  if (user) {
    const token = await firebase.auth().currentUser.getIdToken()
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/getProfile`,
      {
        token,
      }
    )
    user.profile = data

    dispatch({
      type: LOAD_USER,
      payload: user,
    })
  } else {
    dispatch({
      type: AUTH_ERROR,
    })
  }
}

export const updateProfile = ({
  token,
  name,
  lastName,
  birthday,
  gender,
  email,
  authentication,
}) => async (dispatch) => {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_apiUrl}/updateProfile`,
      {
        token,
        name,
        lastName,
        birthday,
        gender,
        email,
      }
    )
    authentication.profile = data
    dispatch({
      type: UPDATE_PROFILE,
      payload: data,
    })
  } catch (error) {
    dispatch({
      type: AUTH_ERROR,
    })
  }
}
